export function removeLegacyPublicOrganizationCaches() {
  try {
    const storage = globalThis.localStorage, keys = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key?.startsWith("lightly:public-org:")) keys.push(key);
    }
    keys.forEach((key) => storage.removeItem(key));
  } catch { /* Storage may be unavailable in private browsing. */ }
}
